import {MouseEventHandler} from 'react';

export type AnchorProps = {
    label?: string
    onClick?: MouseEventHandler<HTMLAnchorElement>,
    href?: string,
    type?: 'primary' | 'secondary'
}

const Anchor = (props: AnchorProps) => {
    return (
        <a className={`dfb-Anchor${props.type === 'secondary' ? ' dfb-Anchor--secondary' : ''}`}
           href={props.href}
           onClick={props.onClick}>
            <span className="dfb-Anchor-label">{props.label}</span>
        </a>
    );
};

export default Anchor;
